export class KeyValue {
  /**
   *
   */
  constructor(key: number, value: string) {
    this.key = key;
    this.value = value;
  }
  key: number = 0;
  value: string = ''; 
}